<dx-popup
  #popup
  [fullScreen]="false"
  [showTitle]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [showCloseButton]="!isLoading"
  title="Dokument aus Vorlage erstellen"
  width="800"
  (onShown)="onPopupShown()"
  [height]="
    isStapeldruck() ? (seriendruckFehler.length > 2 ? 810 : seriendruckFehler.length > 1 ? 790 : seriendruckFehler.length > 0 ? 770 : 690) : 640
  "
>
  <div *dxTemplate="let data of 'content'" class="cz-popup-content">
    @if (ids.length > 1) {
      <div class="seriendruck-info" role="status">{{ ids.length }} {{ getEntityArtMehrzahl() }} werden für den Stapeldruck verwendet.</div>
    }
    <dx-data-grid
      class="vorlagen-datagrid"
      #vorlagenDataGrid
      [dataSource]="dataSource"
      height="340"
      (onSelectionChanged)="onSelectionChanged($event)"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onContentReady)="onContentReady($event)"
    >
      <dxo-remote-operations [filtering]="true" [paging]="true" [sorting]="true" [summary]="true" [grouping]="true" [groupPaging]="true">
      </dxo-remote-operations>

      <dxo-selection selectAllMode="page" mode="single"></dxo-selection>

      <dxo-paging [pageSize]="30"></dxo-paging>
      <dxo-filter-row [visible]="false"></dxo-filter-row>
      <dxo-header-filter [visible]="false"></dxo-header-filter>

      <dxo-search-panel [width]="300" [visible]="true"> </dxo-search-panel>

      <dxi-column dataField="bezeichnung" caption="Bezeichnung"></dxi-column>
      <dxi-column dataField="fileName" caption="Datei"></dxi-column>
      <dxi-column dataField="datum" caption="Änderungsdatum" [width]="150" dataType="date" format="dd.MM.yyyy"> </dxi-column>
    </dx-data-grid>

    <dx-form class="edit-form" #form [width]="'100%'" [formData]="formData" labelLocation="left" [alignItemLabels]="false" [colCount]="2">
      <dxi-item dataField="bezeichnung" [label]="{ text: 'Name des zu erstellenden Dokumentes' }" [colSpan]="2">
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        cssClass="stapeldruck-auswahlfeld stapeldruck-auswahlfeld--ausgabeformat"
        dataField="ausgabeFormat"
        [label]="{ text: 'Ausgabeformat' }"
      >
        <dx-radio-group
          class="ausgabeformat-optionen"
          [items]="ausgabeFormate"
          [(value)]="formData.ausgabeFormat"
          valueExpr="id"
          displayExpr="text"
          layout="vertical"
          (onValueChanged)="onStapeldruckOptionChanged($event)"
        >
        </dx-radio-group>
      </dxi-item>
      <dxi-item cssClass="stapeldruck-auswahlfeld" dataField="anheften" [label]="{ text: 'Dokument anhängen' }">
        <dx-radio-group
          class="anheft-optionen"
          [items]="anheftOptionen"
          [(value)]="formData.anheften"
          valueExpr="id"
          displayExpr="text"
          layout="vertical"
          (onValueChanged)="onStapeldruckOptionChanged($event)"
        >
        </dx-radio-group>
      </dxi-item>
    </dx-form>
    @if (seriendruckFehler.length > 0) {
      <div class="seriendruck-fehler" role="alert" aria-live="assertive">
        <strong>Folgende {{ getEntityArtMehrzahl() }} konnten nicht bearbeitet werden:</strong>
        <ul>
          @for (eintrag of seriendruckFehler; track eintrag.entityId) {
            <li>
              <span class="seriendruck-fehler-kennzeichen">{{ getFehlerKennzeichen(eintrag) }}</span
              >:
              {{ eintrag.fehler }}
            </li>
          }
        </ul>
      </div>
    }

    <dx-load-panel
      shadingColor="rgba(0,0,0,0.35)"
      [visible]="isLoading"
      [position]="{ of: 'window', at: 'center', my: 'center' }"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [hideOnOutsideClick]="false"
      [message]="isStapeldruck() ? 'Stapeldruck wird erstellt. Bitte warten...' : 'Dokument wird erstellt. Bitte warten...'"
      [elementAttr]="{ 'aria-live': 'polite', 'aria-busy': 'true' }"
    >
    </dx-load-panel>
  </div>
  @if (isStapeldruck() && seriendruckFehler.length > 0) {
    <dxi-popup-toolbar-item
      widget="dxButton"
      location="after"
      toolbar="bottom"
      [options]="{
        disabled: isLoading,
        text: 'Fehlerliste herunterladen',
        type: 'default',
        stylingMode: 'contained',
        icon: 'download',
        onClick: onClickFehlerlisteDownload,
      }"
    >
    </dxi-popup-toolbar-item>
  }
  @if (isStapeldruck() && stapeldruckPreviewDokumente.length > 0) {
    <dxi-popup-toolbar-item
      widget="dxButton"
      location="after"
      toolbar="bottom"
      [options]="{
        disabled: isLoading,
        text: 'Vorschau öffnen',
        type: 'default',
        stylingMode: 'contained',
        icon: 'search',
        onClick: onClickStapeldruckPreview,
      }"
    >
    </dxi-popup-toolbar-item>
  }
  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      disabled: !selectedItem || isLoading || (isStapeldruck() && seriendruckAbgeschlossen),
      text: 'Erstellen',
      type: 'default',
      stylingMode: 'contained',
      icon: 'download',
      onClick: onClickErzeugen,
    }"
  >
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      disabled: isLoading,
      text: seriendruckAbgeschlossen ? 'Schließen' : 'Abbrechen',
      type: 'default',
      stylingMode: 'contained',
      icon: 'remove',
      onClick: onClickClose,
    }"
  >
  </dxi-popup-toolbar-item>
</dx-popup>
